import { ChangeDetectorRef, Component, Inject, Injector, OnInit } from '@angular/core';
import { CustomerPermission } from '@models/customerPermission';
import { SubscriptionTypePermission } from '@models/subscriptionTypePermission';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { ComponentSettingsService } from '@services/component-settings/component-settings.service';
import { ConfigurationService } from '@services/configuration/configuration.service';
import { EventService } from '@services/event/event.service';
import { MessageService } from '@services/message/message.service';
import { PermissionsService } from '@services/permissions/permissions.service';

@Component({
  selector: 'app-component-base',
  template: '',
  providers: [ConfigurationService]
})
export abstract class ComponentBase implements OnInit {

  public abstract className: string;

  @Inject(ConfigurationService)
  public configurationService: ConfigurationService;

  @Inject(PermissionsService)
  public permissionsService: PermissionsService;

  @Inject(EventService)
  public eventService: EventService;

  @Inject(MessageService)
  public messageService: MessageService;

  @Inject(AuthenticationService)
  public authenticationService: AuthenticationService;

  @Inject(ComponentSettingsService)
  public componentSettings: ComponentSettingsService;

  public config;
  public permissions = {} as any;

  constructor(injector: Injector) {
    this.configurationService = injector.get(ConfigurationService);
    this.permissionsService = injector.get(PermissionsService);
    this.eventService = injector.get(EventService);
    this.messageService = injector.get(MessageService);
    this.authenticationService = injector.get(AuthenticationService);
    this.componentSettings = injector.get(ComponentSettingsService);

    this.eventService.filesLoaded$.subscribe(result => {
      this.getConfig();
    });

    this.authenticationService.currentUserLoaded$.subscribe(result => {
      this.getConfig();
      this.getPermissions();
    });
  }

  public ngOnInit() {
    this.setDefaultSettings();
    this.getConfig();
    this.getPermissions();
  }

  private setDefaultSettings() {
    //this.componentSettings.footerVisible = false;
  }

  private getConfig() {
    var rolesOfCurrentUser = this.authenticationService.getRolesOfCurrentUser();
    if (rolesOfCurrentUser) {
      this.configurationService.getConfiguration(this.className, rolesOfCurrentUser).then(config => {
        this.config = config;
      });
    }
  }

  private getPermissions() {
    var currentUser = this.authenticationService.getLoggedInUser();
    if (currentUser) {
      this.permissionsService.getPermissionsOfCurrentCustomer().then(permissions => {
        permissions.forEach(permissionObject => {
          this.permissions[permissionObject.permission.name] = permissionObject.value;
        })
      });
    }
  }
}
